<script setup>

const props = defineProps({
  setCursor: {
    type: Function,
    required: true,
  },
});

const isModalOpen = ref(false);

</script>

<template>
	<div
		id="opero-club"
    class="pb-10 md:pt-12"
    @mouseenter="
      setCursor(null, null, {
        'font-size': '14px',
        background: '#fff',
        width: '25px',
        height: '25px',
        'z-index': '1',
        position: 'absolute',
      })
    "
  >
		<ModalForm :set-cursor="setCursor" :isOpen="isModalOpen" @close="isModalOpen = false" />
		<div class="container mx-auto z-10 relative max-w-7xl px-6">
			<template v-if="false">
			<h1 class="text-center mb-5">{{ $t('club.title') }}</h1>
			<p class="text-center text-base lg:text-xl mb-10 lg:mb-20" v-html="$t('club.subtitle')"></p>
			<div class="text-center flex items-center flex-col mb-12">
				<AnimationPaper />
				<p class="text-[28px] font-medium mt-8 lg:mt-10 mb-4">Opero Club</p>
				<p class="text-xl font-medium mb-4">{{ $t('club.price') }}</p>
				<p class="text-xl font-medium">{{ $t('club.price-note') }}</p>
			</div>

			<div class="grid grid-cols-12 lg:gap-5">
				<div class="col-span-12 lg:col-span-4 mb-6 lg:mb-0">
					<div class="bg-white h-full">
						<div class="p-8 lg:p-12">
							<h3 class="mb-8 lg:mb-10 font-light" v-html="$t('club.box1.title')"></h3>
							<p class="border-b border-black border-opacity-20 pb-4 mb-4" v-html="$t('club.box1.point1')"></p>
							<p class="border-b border-black border-opacity-20 pb-4 mb-4" v-html="$t('club.box1.point2')"></p>
							<p class="border-b border-black border-opacity-20 pb-4 mb-4" v-html="$t('club.box1.point3')"></p>
							<p v-if="$i18n.locale === 'cs'" class="border-b border-black border-opacity-20 pb-4 mb-4" v-html="$t('club.box1.point4')"></p>
							<div class="flex items-center">
								<div class="bg-primary rounded-full w-12 h-12 shrink-0 text-xl font-medium flex justify-center items-center mr-4">+1</div>
								<p class="font-medium">{{ $t('club.bring-a-guest') }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-span-12 lg:col-span-4 mb-6 lg:mb-0">
					<div class="bg-white h-full">
						<div class="p-8 lg:p-12">
							<h3 class="mb-8 lg:mb-10 font-light" v-html="$t('club.box2.title')"></h3>
							<p class="border-b border-black border-opacity-20 pb-4 mb-4" v-html="$t('club.box2.point1')"></p>
							<p class="border-b border-black border-opacity-20 pb-4 mb-4" v-html="$t('club.box2.point2')"></p>
							<p class="border-b border-black border-opacity-20 pb-4 mb-4" v-html="$t('club.box2.point3')"></p>
							<div class="flex items-center">
								<div class="bg-primary rounded-full w-12 h-12 shrink-0 text-xl font-medium flex justify-center items-center mr-4">+1</div>
								<p class="font-medium">{{ $t('club.bring-a-guest') }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-span-12 lg:col-span-4">
					<div class="bg-white h-full">
						<div class="p-8 lg:p-12">
							<h3 class="mb-8 lg:mb-10 font-light" v-html="$t('club.box3.title')"></h3>
							<p class="font-medium mb-4" v-html="$t('club.box3.point1')"></p>
							<p v-html="$t('club.box3.point2')"></p>
						</div>
					</div>
				</div>
			</div>
			</template>

			<!-- <div class="text-center mb-16 md:mb-24"> -->
				<button
					id="opero-club-form-trigger"
					@click="isModalOpen = true"
					class="hidden bg-transparent border rounded-full border-black text-lg text-black px-4 py-2 mt-6"
				>
					{{ $t("want-to-try-it") }}
				</button>
			<!-- </div> -->

			<h2 class="h1 pt-12 mb-8">{{ $t("membership.testimonials.title") }}</h2>
			<ClubMembershipCarousel :set-cursor="setCursor" />

		</div>
	</div>
</template>